export default __webpack_public_path__ + "static/media/gallery01.7f049dfe.png";